import {MessageSend, messageType} from '../../../../../../../util/uiconstants';
import {
	FROM_ENTITY,
	SUBJECT,
	TYPE,
	FROM_ENTITY_NOTIFICATION,
	NOTIFICATION_MESSAGE,
	LINK_LABEL,
	LINK,
	FROM_ENGAGEMENT
} from './constants';
import {currentResource} from '../../../../../../../util/utils';
import {ContactsDBFilterTypeQuery} from '../../../../../../../util/uiconstants';

const mapGeneric = ({id, label: name}) => ({id: id.toString(), name});

const normalizeListFilters = (field, filtersData, filtersList) => {
	let formattedData = [];

	filtersData[field].map((id) => {
		if (field === ContactsDBFilterTypeQuery.byGroupRole) {
			const contactGroup = currentResource.groupRole.find((obj) => obj.id === id);
			formattedData.push({
				id: contactGroup.id.toString(),
				name: contactGroup.label
			});
		} else {
			formattedData.push({
				id: id.toString(),
				name: filtersList[field]?.byId[id].label
			});
		}
	});

	return formattedData;
};

const getFilters = (filtersData, filtersList, orgChart, entities) => {
	const filters = {};
	let recipientType = messageType.bulk;

	if (Object.keys(filtersData)?.length > 0 || orgChart.length > entities.length) {
		recipientType = messageType.filters;
		if (filtersData.contactsbycountry?.length > 0) {
			filters.countries = normalizeListFilters(ContactsDBFilterTypeQuery.byCountry, filtersData, filtersList);
		}
		if (filtersData.contactsbyserviceline?.length > 0) {
			filters.serviceLine = normalizeListFilters(ContactsDBFilterTypeQuery.byServiceLine, filtersData, filtersList);
		}
		if (filtersData.contactsbyrole?.length > 0) {
			filters.roles = normalizeListFilters(ContactsDBFilterTypeQuery.byRole, filtersData, filtersList);
		}
		if (filtersData.contactsbygrouprole?.length > 0) {
			filters.groupRoles = normalizeListFilters(ContactsDBFilterTypeQuery.byGroupRole, filtersData, filtersList);
		}
		if (filtersData.contactsbyengagement?.length > 0) {
			filters.engagements = normalizeListFilters(ContactsDBFilterTypeQuery.byEngagement, filtersData, filtersList);
		}
		if (orgChart.length > entities.length) {
			const entitiesSelected = orgChart.filter((obj) => entities.some((entity) => obj.id === entity.id));
			filters.entities = entitiesSelected.map((entity) => {
				return {
					id: entity.id,
					entityId: entity.entityId,
					parentEntityId: entity.parentId,
					entityName: entity.label,
					entityLevel: entity.entityLevel,
					isChecked: entity.checked
				};
			});
		}
	}

	return {filters, recipientType};
};

const normalizeLink = (link) =>
	!link.toLowerCase().startsWith('https://') && !link.toLowerCase().startsWith('http://') ? `https://${link}` : link;

export default ({contacts, values, filtersData = {}, filtersList, typeEmail, orgChart, entities, duplicateFilters}) => {
	const payload = {};
	let actualFilters = {};

	if (duplicateFilters === null) {
		const {filters, recipientType} = getFilters(filtersData, filtersList, orgChart, entities);
		actualFilters = {...filters};
		payload.recipientType = recipientType;
	} else {
		const {
			countriesList: countries,
			serviceLineList: serviceLine,
			rolesList: roles,
			groupRolesList: groupRoles,
			engagementsList: engagements,
			entitiesList: entities
		} = duplicateFilters;
		actualFilters = {countries, serviceLine, roles, groupRoles, engagements, entities};
		payload.recipientType = messageType.duplicate;
	}

	if (values[TYPE].id === typeEmail.id) {
		const message = {
			contacts: [...contacts],
			subject: values[SUBJECT],
			fromEntity: [values[FROM_ENTITY]].map(mapGeneric)[0]
		};

		payload.messageType = MessageSend.Email;
		payload.email = {...actualFilters, ...message};
	} else {
		const message = {
			contacts: [...contacts],
			message: values[NOTIFICATION_MESSAGE],
			toastMessage: values[FROM_ENTITY_NOTIFICATION]?.label,
			linkLabel: values[LINK_LABEL],
			link: normalizeLink(values[LINK]),
			fromEngagement: {
				id: values[FROM_ENGAGEMENT]?.id.toString(),
				name: values[FROM_ENGAGEMENT]?.label
			},
			fromEntity: {
				id: values[FROM_ENTITY_NOTIFICATION]?.id.toString(),
				name: values[FROM_ENTITY_NOTIFICATION]?.label
			}
		};

		payload.messageType = MessageSend.Notification;
		payload.notification = {...actualFilters, ...message};
	}

	return payload;
};
